import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";

const DeviceFilterCard = ({
  filters,
  handleFilterChange,
  handleClearFilters,
  setCurrentPage,
  onAddNewClick,
}) => {
  return (
    <>
      <Row className="">
        <Col lg="12">
          <Card className="border-0 shadow-sm">
            <CardHeader className="bg-light">
              <Row className="align-items-center justify-content-between w-100">
                <Col md="auto">
                  <h5 className="mb-0 d-flex align-items-center gap-2">
                    <i className="bx bx-filter-alt"></i> Search & Filter
                  </h5>
                </Col>

                <Col md="auto" className="d-flex gap-2">
                  <Button
                    color="primary"
                    size="sm"
                    onClick={() => setCurrentPage(1)}
                  >
                    <i className="bx bx-search me-2"></i>Apply Filters
                  </Button>
                  <Button
                    color="secondary"
                    outline
                    size="sm"
                    onClick={handleClearFilters}
                  >
                    <i className="bx bx-reset me-2"></i>Clear All
                  </Button>

                  <Button color="success" size="sm" onClick={onAddNewClick}>
                    <i className="bx bx-plus me-2"></i>
                    Register Device
                  </Button>
                </Col>
              </Row>
            </CardHeader>

            <CardBody>
              <Row className="align-items-end justify-content-between g-3">
                {/* 🔹 Left Side (Search Filters) */}
                <Col md="12">
                  <Row className="g-3">
                    {/* Device Name */}
                    <Col md="3">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Device Name</Label>
                        <Input
                          type="text"
                          placeholder="Search by name..."
                          value={filters.searchText}
                          onChange={(e) =>
                            handleFilterChange("searchText", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* Org Code */}
                    <Col md="3">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Org Code</Label>
                        <Input
                          type="text"
                          placeholder="Search by org code..."
                          value={filters.orgCode}
                          onChange={(e) =>
                            handleFilterChange("orgCode", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* Location */}
                    <Col md="2">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Location</Label>
                        <Input
                          type="text"
                          placeholder="Search by location..."
                          value={filters.location}
                          onChange={(e) =>
                            handleFilterChange("location", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* MAC ID */}
                    <Col md="2">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">MAC ID</Label>
                        <Input
                          type="text"
                          placeholder="Search by MAC ID..."
                          value={filters.macId}
                          onChange={(e) =>
                            handleFilterChange("macId", e.target.value)
                          }
                          bsSize="md"
                        />
                      </FormGroup>
                    </Col>

                    {/* Only With Devices */}
                    <Col md="2">
                      <FormGroup className="mb-0">
                        <Label className="small fw-bold">Status</Label>
                        <Input
                          type="select"
                          value={filters.onlyWithDevices}
                          onChange={(e) =>
                            handleFilterChange(
                              "onlyWithDevices",
                              e.target.value === "true"
                            )
                          }
                          bsSize="md"
                        >
                          <option value={false}>All Devices</option>
                          <option value={true}>Only With Devices</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default DeviceFilterCard;
